// AUDIT-FIX shared-contract (STEIER-P1-03) — the ONE uniform API error shape.
// The Core API emits every failure through UniformExceptionFilter
// (apps/api/src/common/uniform-exception.filter.ts) as
//   { statusCode, error, message, correlationId }
// and the correlationId is what ties a client-side failure to the server logs
// (LLD-01 §10). Both frontends parse the body through this module — neither
// re-declares the shape nor discards fields (the field app previously threw the
// body away entirely; that is the P1-03 drift this module closes).
//
// PURE module: types + pure functions only — no Node imports (bundled by Vite
// and Metro via the @steier/shared/contract subpath).
function nonEmptyString(value) {
    return typeof value === "string" && value.trim().length > 0 ? value : null;
}
/**
 * Safely narrow an untrusted response body to the uniform shape. Anything that
 * is not a plain object (HTML error pages, empty bodies, plain strings) yields
 * `{}` — parsing an error must never itself throw.
 */
export function parseApiErrorBody(data) {
    if (data === null || typeof data !== "object" || Array.isArray(data))
        return {};
    const raw = data;
    const body = {};
    if (typeof raw.statusCode === "number")
        body.statusCode = raw.statusCode;
    if (typeof raw.error === "string")
        body.error = raw.error;
    if (typeof raw.message === "string")
        body.message = raw.message;
    else if (Array.isArray(raw.message) && raw.message.every((m) => typeof m === "string")) {
        body.message = raw.message;
    }
    if (typeof raw.correlationId === "string")
        body.correlationId = raw.correlationId;
    return body;
}
/** Join the (possibly array-valued) uniform message into one display string. */
export function joinApiErrorMessage(message) {
    if (Array.isArray(message))
        return nonEmptyString(message.join(" "));
    return nonEmptyString(message);
}
/**
 * Parse one API failure into the normalised projection both frontends consume.
 * `headers` (lower-cased keys, as Axios/fetch expose them) supplies the
 * `x-correlation-id` fallback when the body carries none.
 */
export function parseApiError(status, data, headers) {
    const body = parseApiErrorBody(data);
    const headerCorrelation = headers && typeof headers["x-correlation-id"] === "string"
        ? headers["x-correlation-id"]
        : null;
    return {
        status,
        code: nonEmptyString(body.error),
        message: joinApiErrorMessage(body.message),
        correlationId: nonEmptyString(body.correlationId) ?? nonEmptyString(headerCorrelation),
    };
}
//# sourceMappingURL=api-error.js.map